import { render, staticRenderFns } from "./WipDelivery.vue?vue&type=template&id=cf10a030&scoped=true"
import script from "./WipDelivery.vue?vue&type=script&lang=ts"
export * from "./WipDelivery.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cf10a030",
  null
  
)

export default component.exports